// extracted by mini-css-extract-plugin
export default {"multiboxComponent":"Multibox-module__multiboxComponent___d3mPQ","checkboxWrapper":"Multibox-module__checkboxWrapper___cBpVc"};